import {
	SERVER_URL,
	SERVER_SOCKET_URL,
	SOCKET_SERVER,
	STRIPE_KEY,
	NEXT_PUBLIC_STRIPE_LIVE_KEY,
	CLIENT_URL,
	NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
	NEXT_PUBLIC_FIREBASE_API_KEY,
	NEXT_PUBLIC_FIREBASE_APP_ID,
	NEXT_PUBLIC_FACEBOOK_CLIENT_SECRET,
	NEXT_PUBLIC_SERVER_URL
} from '@env';

export default {
	SERVER_URL,
	SERVER_SOCKET_URL,
	SOCKET_SERVER,
	STRIPE_KEY,
	NEXT_PUBLIC_STRIPE_LIVE_KEY,
	CLIENT_URL,
	GOOGLE_MAPS_API_KEY: NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
	FIREBASE_API_KEY: NEXT_PUBLIC_FIREBASE_API_KEY,
	FIREBASE_APP_ID: NEXT_PUBLIC_FIREBASE_APP_ID,
	FACEBOOK_CLIENT_SECRET: NEXT_PUBLIC_FACEBOOK_CLIENT_SECRET,
	NEXT_PUBLIC_SERVER_URL
};
